<template>
  <div class="">
    <div class="wpcm-row wpcm-justify-content-center">
      <div class="wpcm-col-sm-12 wpcm-s3-dropdown">
        <slot name="donation_dropdowns"></slot>
        <div
          class="el-custom-select mt-5"
          v-if="show_currency_dropdown && currencies"
        >
          <el-select
            class="w-100"
            v-model="store.currency"
            @change="setValue('currency', $event)"
            placeholder="Select Currency"
          >
            <el-option
              :value="key"
              :key="key"
              :label="curr"
              v-for="(curr, key) in currencies"
              >{{ curr }}</el-option
            >
          </el-select>
        </div>
        <div class="el-custom-select" v-if="show_custom_dropdown">
        <el-select class="w-100" v-model="selectedCustom" @change="setValue('custom', $event)" placeholder="Select">
          <el-option v-for="(cus, key) in donation_custom_dropdown" :key="key" aria-placeholder="seelct" :value="key" :label="cus">
            {{ cus }}
          </el-option>
        </el-select>
      </div>
      <slot name="donation_dropdowns"></slot>
        <div class="donation-amount-box my-5">
          <!-- <h4>How much would you like to donate?</h4> -->
          <div class="custom-donation-amount wpcm-d-inline-block" v-if="custom_amount">
            <span>{{ getSymbol() }}</span> 
            <input type="text" v-model="store.amount">
          </div>
          <div class="custom-donation-amount wpcm-d-inline-block" v-else-if="!custom_amount && display_amount">
            <span>{{ getSymbol() }}</span>
            <span>{{ display_amount }}</span>
          </div>
          <div class="donation-amount-list">
            <ul class="list-unstyled" v-if="show_amounts && amounts">
              <li
                v-for="amnt in amounts"
                :key="amnt"
                @click.prevent="store.amount = convert(amnt)"
              >
                <a
                  href="#"
                  :class="[
                    'wpdonation-button',
                    store.amount == amnt && 'active'
                  ]"
                >
                  {{ getSymbol() + ' ' + amnt }}</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useDonationFormsStore } from '../../store';

const store = useDonationFormsStore();
const props = defineProps([
  "currencies",
  "symbols",
  "symbol",
  "amounts",
  "strings",
  "show_currency_dropdown",
  "show_amounts",
  "custom_amount",
  "show_recurring",
  "display_amount"
]);
const lifeline_donation = globalThis.lifeline_donation;
const _ = globalThis._;

const setValue = (key, val) => {
  store[key] = val;
};
const getSymbol = () => {
  return (props.symbols[store.currency] != undefined) ? props.symbols[store.currency] : props.symbol
};
const convert = (amt: number) => {
  const { exchange_rates } = lifeline_donation
  const syb = store.currency

  if(_.get(exchange_rates, syb)) {
    return (_.get(exchange_rates, syb) * amt).toFixed(2);
  }
  return amt
};

onMounted(() => {
  if(props.show_amounts && _.size(props.amounts)) {
    setValue('amount', props.amounts[0])
  }
  if(props.show_currency_dropdown && _.size(props.currencies)) {
    setValue('currency', _.keys(props.currencies)[0])
  }
  if (props.display_amount) {
    store.amount = props.display_amount;
  }
});


</script>
